import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { register } from '../Redux/Actions/AuthActions';
import './ProviderRegister.css';
import logo from "../image/bookly_logo.png";
import axios from 'axios';

const ProviderRegister = () => {
  const [businessName, setBusinessName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [activity, setActivity] = useState('Coiffure');
  const [phone, setPhone] = useState('');
  const [adress, setAdress] = useState('');
  const [localError, setLocalError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setLocalError("Les mots de passe ne correspondent pas.");
      return;
    }
    setLocalError('');
    setSuccessMessage('');

    const providerData = {
      email,
      password,
      role: 'provider',
      businessName,
      activity,
      phone: (phone && phone.trim()) ? parseInt(phone) : undefined,
      adress,
    };

    // We call register but we intercept the navigation because for providers
    // it won't return a token immediately since it is pending admin approval.
    dispatch(register(providerData, (path) => {
      // If the registration is successful and no token is returned, 
      // we show a success status instead of auto-logging in.
      const token = localStorage.getItem('token');
      if (!token) {
        setSuccessMessage("Votre inscription a été enregistrée avec succès ! Votre compte est actuellement en attente d'approbation par l'administrateur. Vous recevrez un e-mail dès sa validation.");
        setBusinessName('');
        setEmail('');
        setPassword('');
        setConfirmPassword('');
        setPhone('');
        setAdress('');
      } else {
        navigate('/');
      }
    }));
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 provider-register-background">
      <div className="provider-register-container shadow rounded p-5 text-center">
        <img src={logo} alt="Bookly Logo" className="mb-4 provider-logo-img" />
        <h4 className="mb-3 text-secondary font-weight-bold">Espace Prestataire</h4>
        <p className="text-muted small mb-4">Inscrivez votre établissement pour proposer vos prestations de service sur Bookly</p>

        {localError && (
          <div className="alert alert-danger" role="alert">
            {localError}
          </div>
        )}

        {successMessage ? (
          <div className="alert alert-success py-4" role="alert">
            <h5 className="font-weight-bold mb-3">En attente d'approbation</h5>
            <p className="mb-4 text-start" style={{ fontSize: '14px', lineHeight: '1.6' }}>
              {successMessage}
            </p>
            <Link to="/Login">
              <Button variant="outline-success" className="px-4">Retourner à la connexion</Button>
            </Link>
          </div>
        ) : (
          <Form onSubmit={handleRegister}>
            <Form.Group className="mb-3 text-start">
              <Form.Label>Nom de l'établissement</Form.Label>
              <Form.Control
                onChange={(e) => setBusinessName(e.target.value)}
                type="text"
                placeholder="Ex: Institut Beauté & Spa"
                className="input-field"
                value={businessName}
                required
              />
            </Form.Group>

             <Form.Group className="mb-3 text-start">
               <Form.Label>Secteur d'activité</Form.Label>
               <Form.Select
                 value={activity}
                 onChange={(e) => setActivity(e.target.value)}
                 className="input-field select-field"
               >
                 <option value="Coiffure">💇 Salon de Coiffure</option>
                 <option value="Spa">💆 Spa & Massage</option>
                 <option value="Onglerie">💅 Onglerie</option>
                 <option value="Sport">🏋️ Salle de Sport</option>
                 <option value="Terrains">🎾 Terrains de Sport</option>
                 <option value="Bowling">🎳 Bowling</option>
                 <option value="Gaming">🎮 Gaming Center</option>
                 <option value="Billard">🎱 Billard</option>
                 <option value="Restaurant">🍽️ Restaurant (créneaux)</option>
                 <option value="Evenementiel">🎉 Espace Événementiel</option>
                 <option value="Freelance">👨‍💼 Indépendants / Freelance</option>
                 <option value="Photographes">📸 Photographe</option>
                 <option value="Ateliers">🎨 Formation & Ateliers</option>
                 <option value="Lavage">🚗 Lavage Automobile</option>
                 <option value="Jeux">🧒 Aire de Jeux pour enfants</option>
                 <option value="Tourisme">🚤 Activité Touristique</option>
                 <option value="Loisirs">🏕️ Loisirs & Camping</option>
                 <option value="Coaching">🧑‍🏫 Coaching / Professeur</option>
                 <option value="Coworking">🏠 Espace de Coworking</option>
                 <option value="Etudes">📚 Bibliothèque / Salle d'étude</option>
                 <option value="Studio">🎤 Studio d'Enregistrement</option>
               </Form.Select>
             </Form.Group>

            <Form.Group className="mb-3 text-start">
              <Form.Label>Adresse Email professionnelle</Form.Label>
              <Form.Control
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="contact@votre-spa.com"
                className="input-field"
                value={email}
                required
              />
            </Form.Group>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3 text-start">
                  <Form.Label>Téléphone</Form.Label>
                  <Form.Control
                    onChange={(e) => setPhone(e.target.value)}
                    type="tel"
                    placeholder="Ex: 55123456"
                    className="input-field"
                    value={phone}
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3 text-start">
                  <Form.Label>Adresse physique</Form.Label>
                  <Form.Control
                    onChange={(e) => setAdress(e.target.value)}
                    type="text"
                    placeholder="Ex: Rue des Fleurs, Tunis"
                    className="input-field"
                    value={adress}
                  />
                </Form.Group>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <Form.Group className="mb-3 text-start">
                  <Form.Label>Mot de passe</Form.Label>
                  <Form.Control
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    placeholder="••••••••"
                    className="input-field"
                    value={password}
                    required
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="mb-3 text-start">
                  <Form.Label>Confirmation</Form.Label>
                  <Form.Control
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    type="password"
                    placeholder="••••••••"
                    className="input-field"
                    value={confirmPassword}
                    required
                  />
                </Form.Group>
              </div>
            </div>

            <Button variant="primary" type="submit" className="w-100 btn-submit mt-3 mb-3">
              Soumettre ma demande
            </Button>

            <div className="text-center mt-3 text-muted" style={{ fontSize: '14px' }}>
              <span>Déjà inscrit ? <Link to="/ProviderLogin">Se connecter</Link></span>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default ProviderRegister;
